export default "__VITE_ASSET__BMszPTjJ__"